<mat-dialog-content class="modal-header">
    <h2 mat-dialog-title>CONFIRMAR LA SOLICITUD DE AMPLIACIÓN</h2>
  </mat-dialog-content>
  
  <form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>

  <mat-dialog-content class="modal-body">
    <div class="block-content">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-3 control-label">Justificación:</label>
          <div class="col-md-9">
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Ingresa los comentarios</mat-label>
              <textarea
                [(ngModel)]="model.comentarios"
                matInput
                placeholder="Comentarios"
                rows="5"
                name="comentarios" [maxlength]="2000"
                required
              >
              </textarea>
              <!-- [(ngModel)]="model.comentarios"> -->
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end" class="modal-actions">
    <button
      type="submit"
      class="btn btn-naranja"
      mat-button
      [mat-dialog-close]="model"
      [disabled]="modelForm.invalid"
      cdkFocusInitial
    >
    <mat-icon>send</mat-icon> GENERAR SOLICITUD
    </button>
    <button type="button" class="btn btn-naranja2" mat-button (click)="onNoClick()">
      <mat-icon>exit_to_app</mat-icon> Cancelar
    </button>
  </mat-dialog-actions>
</form>